import React from "react";
import "../index.css";

export const MultipleSelectBox = ({
  label,
  value,
  setValue,
  options,
  isSecondData,
  secondData,
  setSecondData,
}) => {
  return (
    <div className="product-multiple-inputs-bg">
      <p>{label}</p>
      <select
        className="product-multiple-inputs-input"
        value={value}
        onChange={(e) => {
          const selectedValue = e.target.value;
          setValue(selectedValue);

          if (isSecondData) {
            const selectedOption = options.find(
              (option) => option.value === selectedValue
            );

            if (selectedOption && secondData && selectedOption[secondData]) {
              setSecondData(selectedOption[secondData]);
            }
          }
        }}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
